<template>

  <transition name="fade">
  <div v-bind:key="show" v-if="$store.getters.votes">

    <div class="hit-panel hit-panel-default" v-for="(feedback, index) in get_feedbacks" v-show="index == show">

      <div  class="hit-panel-heading" v-html="$tc('message.idea', 2)+' / '+$tc('message.suggestionForImprovement', 2)+' (#'+feedback.board+'-'+feedback.ID+')'" />

      <div v-if="get_feedbacks.length">

      <div class="hit-panel-body hit-text-center">
        <div><hit_icon :id="'user'" /> {{ feedback.name }}</div>
        <blockquote class="hit-html-blockquote" v-html="feedback.hint"/>
        <small class="hit-html-small"><hit_icon :id="'calendar'"/> {{ feedback.time }}</small>&nbsp;
        <small class="hit-html-small">@ {{ $tc("message.board",1) }} {{ $store.getters.boards_by_id[feedback.board].name }}</small>
      </div>
      <router-link v-html="$t('message.goTo', {name: $tc('message.feedback', 1)+' '+feedback.name})" class="hit-btn hit-btn-primary hit-btn-block" :to="{ name:'feedback_details', params: {lang: $store.getters.lang, entryID: get_md5(feedback.ID), boardID: get_md5(feedback.board)} }"></router-link>

      <div class="hit-panel-footer" v-if="get_feedbacks.length">
        <div class="hit-pull-left" v-html="(index + 1)+'/'+get_feedbacks.length"></div>
        <div class="hit-text-right" v-if="get_feedbacks.length > 1">
          <a href="#" class="hit-html-a" v-on:click.prevent="set_show('previous')"><i class="hit-glyphicon hit-glyphicon-arrow-left"></i> {{ $t("message.previous") }}</a> | <a href="#" class="hit-html-a" v-on:click.prevent="set_show('next')">{{ $t("message.next") }} <i class="hit-glyphicon hit-glyphicon-arrow-right"></i></a>
        </div>
        <div class="hit-clearfix" />
      </div>

    </div>

    <div v-if="!get_feedbacks.length" class="hit-panel-body hit-text-center" v-html="$tc('message.noEntry', 2)"></div>

    </div>
  </div>
</transition>

</template>

<script>

import md5 from 'js-md5'

export default{

  data () {
    return {
      show: 0
    }
  },

  methods: {

    set_show: function (pos) {
      if (pos == 'next') {
        this.show = this.show + 1

        if (this.show == this.get_feedbacks.length) { this.show = 0 }
      } else {
        this.show = this.show - 1

        if (this.show == -1) { this.show = this.get_feedbacks.length - 1 }
      }
    },

    get_md5: function (data) {
      return md5('' + data)
    },


  },

  computed: {

    get_feedbacks: function () {
      var r = []

      if (typeof this.$store.getters.votes === 'undefined' || !this.$store.getters.votes.length) { return r }

      var i = 0;

      for (var vote in this.$store.getters.votes) {


        var v = this.$store.getters.votes[vote];

        if (v.hint) {
          i++;

          if(i > 50)
            return r;
            
          r.push(v)
        }
      }

      return r;
    }
  }
}

</script>

<style scoped>

blockquote{
	border: 0;
	text-align: center;
}

</style>
